"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactorySpaced = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var css_types_1 = require("../internal/css-types");
var factory_1 = require("../internal/factory");
var StyledChildren = function (props) {
    var classnames = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.filter(function (a) { return a !== undefined; }).join(' ');
    };
    var styledChildren = react_1.default.Children.map(props.children, function (child) {
        if (react_1.default.isValidElement(child)) {
            return react_1.default.cloneElement(child, {
                className: classnames(child.props.className, props.className)
            });
        }
        return child;
    });
    return react_1.default.createElement(react_1.default.Fragment, null, styledChildren);
};
exports.FactorySpaced = factory_1.factory({
    prefix: 'Spaced',
    settings: { spacing: css_types_1.measureUnit },
    component: function (settings) {
        return styled_components_1.default(StyledChildren)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      /* Add spacing too all children but the last */\n      &:not(:last-child) {\n        ", "\n      }\n    "], ["\n      /* Add spacing too all children but the last */\n      &:not(:last-child) {\n        ",
            "\n      }\n    "])), function (p) {
            var _a;
            // Compute the spacing between each child
            var steppedSpacing = "calc(" + settings.spacing + " * " + ((_a = p.steps) !== null && _a !== void 0 ? _a : 1) + ")";
            // Add margin to children at the positions specified by props
            return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            margin: ", " ", "\n              ", " ", ";\n          "], ["\n            margin: ", " ", "\n              ", " ", ";\n          "])), p.top === true ? steppedSpacing : 0, p.right === true ? steppedSpacing : 0, p.bottom === true ? steppedSpacing : 0, p.left === true ? steppedSpacing : 0);
        });
    }
}).FactorySpaced;
var templateObject_1, templateObject_2;
